<template>
  <div class="third">
    <!-- Hero 区域 -->
    <div class="advantage">
      <div class="hero-text-container">
        <h1 class="">越璋核心优势</h1>
        <p class="">技术驱动 · 资源壁垒 · 模式保障</p>
      </div>
      <div class="hero-m-container">
        <div class="con">
          <div class="">
            <img src="../../assets/images/hxys/jsqd.png">
          </div>
          <h2 class="">技术驱动的极致效果</h2>
          <div class="sm">懂平台、懂流量、懂用户、懂内容</div>
          <div class="sm">RPA技术贯穿项目全流程，实现数据驱动的高效运营</div>
          <a @click="more('jsqd')">了解更多&nbsp;&nbsp;<i class="el-icon-right"></i></a>
        </div>
        <div class="con">
          <div class="">
            <img src="../../assets/images/hxys/zyys.png">
          </div>
          <h2 class="">资源优势</h2>
          <p class="">行业稀缺资源壁垒，构建不可复制的竞争优势</p>
          <a @click="more('zyys')">了解更多&nbsp;&nbsp;<i class="el-icon-right"></i></a>
        </div>
        <div class="con">
          <div class="">
            <img src="../../assets/images/hxys/msys.png">
          </div>
          <h2 class="">模式优势</h2>
          <p class="">效果确定的保障模式，敢于对赌彰显实力</p>
          <a @click="more('msys')">了解更多&nbsp;&nbsp;<i class="el-icon-right"></i></a>
        </div>
      </div>
    </div>
    <div class="jsqd">
      <div class="jsqd-container">
        <div class="jsqd-title" id="jsqd">技术驱动的极致效果</div>
        <p style="text-align: center">懂平台、懂流量、懂用户、懂内容，用RPA+AI构建完整数据模型，创造确定性迭代复利的商业价值</p>
      </div>
    </div>
    <!-- 新增：技术赋能+核心能力+技术工作流模块（图片样式还原） -->
    <div class="tech-drive">
      <div class="tech-drive-container">
        <!-- 技术赋能三件事 -->
        <div class="tech-empower">
          <p class="empower-title">技术赋能三件事</p>
          <p class="empower-subtitle">看清用户、投准流量、写对内容</p>
        </div>
        <!-- 越璋核心能力 -->
        <div class="core-ability">
          <h2 class="ability-main-title">越璋核心能力</h2>
          <p class="ability-subtitle">技术驱动的三个核心维度，创造全新价值</p>

          <div class="ability-list">
            <div class="ability-item">
              <img src="../../assets/images/hxys/智能决策.png" alt="数据模型构建能力" class="item-icon">
              <h3 class="item-title">数据模型构建能力</h3>
              <p class="item-desc">为每个客户构建数据漏斗，基于品牌自身数据构建优化模型，助力高效决策，验证决策结果。</p>
            </div>
            <div class="ability-item">
              <img src="../../assets/images/hxys/精准匹配.png" alt="达人与内容精准匹配" class="item-icon">
              <h3 class="item-title">达人与内容精准匹配</h3>
              <p class="item-desc">用技术快速降维，用数据精准锁定，用经验定义内容方向，用关键词保障确定性收割——让达人与内容，高度匹配。</p>
            </div>
            <div class="ability-item">
              <img src="../../assets/images/hxys/实时优化.png" alt="加速优质内容放大效率" class="item-icon">
              <h3 class="item-title">加速优质内容放大效率</h3>
              <p class="item-desc">数据分析速度快，RPA实时止损效率高，数据模型可视化程度高，费用损耗低。</p>
            </div>
          </div>
        </div>

        <!-- 技术工作流 -->
        <div class="tech-workflow">
          <h2 class="workflow-main-title">技术工作流</h2>
          <p class="workflow-subtitle">从数据到决策的完整技术闭环</p>
          <div class="jsqd-content">
            <a-timeline pending>
              <a-timeline-item>
                <img slot="dot" src="../../assets/images/hxys/ch.png" alt="" style="border-radius: 50%;">
                <div class="con">
                  <h2>数据采集处理</h2>
                  <p>品牌自有数据、竞品数据、达人数据、行业数据、跨平台数据......</p>
                </div>
              </a-timeline-item>
              <a-timeline-item>
                <img slot="dot" src="../../assets/images/hxys/drsx.png">
                <div class="con">
                  <h2>智能分析与预测</h2>
                  <p>深度分析数据，识别隐藏模式与趋势，预测爆文概率与收割效率，输出科学决策依据。</p>
                </div>
              </a-timeline-item>
              <a-timeline-item>
                <img slot="dot" src="../../assets/images/hxys/xxltf.png">
                <div class="con">
                  <h2>精准匹配与执行</h2>
                  <p>基于达人、内容、关键词、投流工具的组合分析，智能匹配最优资源组合。</p>
                </div>
              </a-timeline-item>
              <a-timeline-item>
                <img slot="dot" src="../../assets/images/hxys/SSYHYDD.png">
                <div class="con">
                  <h2>实时优化与迭代</h2>
                  <p>7×24小时监控执行效果，实时调整优化策略，持续学习与进化，每一次执行都为下一次做得更好。</p>
                </div>
              </a-timeline-item>
            </a-timeline>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术驱动的极致效果 原有区域 -->


    <!-- 资源优势 原有区域 -->
    <div class="zyys">
      <div class="zyys-container">
        <div class="zyys-title" id="zyys">
          资源优势
        </div>
        <p style="text-align: center">为什么我们敢于对赌效果，而别人只能"尽力而为"</p>
        <div class="zyys-content">
          <div class="con">
            <div class="item one">
              <div class="title">50万+</div>
              <div class="text-2xl">合作达人</div>
              <div class="fas">
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>全平台覆盖</span>
                </div>
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>深度数据标签</span>
                </div>
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>多维度标签（配合度、内容能力、粉丝画像）</span>
                </div>
              </div>
              <div class="bottom">
                <div class="left-sh"></div>
                <p>50万合作达人不是数字，是<span>50万次合作验证的精准标签</span></p>
              </div>
            </div>
            <div class="item two">
              <div class="title">15万+</div>
              <div class="text-2xl">反馈群</div>
              <div class="fas">
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>3000万+粉丝覆盖</span>
                </div>
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>真实互动数据</span>
                </div>
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>可量化效果（ROI保障基础）</span>
                </div>
              </div>
              <div class="bottom">
                <div class="left-sh"></div>
                <p>15万私域群不是概念，是<span>3000万真实用户的信任网络</span></p>
              </div>
            </div>
            <div class="item three">
              <div class="title">200万+</div>
              <div class="text-2xl">精准宝妈</div>
              <div class="fas">
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>1万+活跃社区群</span>
                </div>
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>高信任关系</span>
                </div>
                <div class="text">
                  <i class="el-icon-success"></i>
                  <span>可精准触达（派样验证需求）</span>
                </div>
              </div>
              <div class="bottom">
                <div class="left-sh"></div>
                <p>200万宝妈不是数据，是<span>600万次派样验证的沉淀资产</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 模式优势 原有区域 -->
    <div class="msys">
      <div class="msys-container">
        <div class="msys-title" id="msys">
          越璋模式优势
        </div>
        <p style="text-align: center">效果确定的保障模式，资源成就对赌底气</p>
        <div class="msys-content">
          <div class="con">
            <div class="title">
              对赌有保障
            </div>
            <div class="content">
              <el-row :gutter="40">
                <el-col :span="12">
                  <div class="item one">
                    <div class="item-title">
                      <img src="../../assets/images/hxys/msys1.png">
                      <span>ROI对赌</span>
                    </div>
                    <div class="item-content">
                      <p class="">基于海量数据支撑，我们敢于承诺投资回报率</p>
                    </div>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="item two">
                    <div class="item-title">
                      <img src="../../assets/images/hxys/msys2.png">
                      <span>内容数据对赌</span>
                    </div>
                    <div class="item-content">
                      <div>
                        <i class="el-icon-success"></i>
                        <span>爆文率</span>
                      </div>
                      <div>
                        <i class="el-icon-success"></i>
                        <span>CPE（单次互动成本）</span>
                      </div>
                      <div>
                        <i class="el-icon-success"></i>
                        <span>CPC（单次点击成本）</span>
                      </div>
                      <div>
                        <i class="el-icon-success"></i>
                        <span>CPM（千次展现成本）</span>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="item three">
                    <div class="item-title">
                      <img src="../../assets/images/hxys/msys3.png">
                      <span>投流数据指标对赌</span>
                    </div>
                    <div class="item-content">
                      <div><span class="font-semibold">ROI：</span>投资回报率保障</div>
                      <div><span class="font-semibold">CPUV：</span>单次用户价值保障</div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </div>
            <div class="foot">
              <div class="foot-btn">敢于承诺，源于实力</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部咨询 原有区域 -->
    <div class="body-foot">
      <div class="con">
        <h2>选我们做你结果共担的合作伙伴，做你流量突围的联合操盘手。</h2>
        <div>
          <el-button @click="ljzx">
            <a-icon type="wechat" />
            立即咨询
          </el-button>
          <el-button @click="zxzx" style="background-color: #FF6700;border-color: #FF6700;color: #ffffff;">
            <a-icon type="qrcode" />
            在线咨询
          </el-button>
        </div>
      </div>
    </div>

    <LjzxDialog :visible.sync="ljzxOpen" @closeDialog="closeDialog"></LjzxDialog>

    <OnlineDialog :visible.sync="zxzxOpen" @closeDialog="closeZxzxDialog"></OnlineDialog>
  </div>
</template>

<script>
import LjzxDialog from "@/components/Dialog/ljzxDialog.vue";
import OnlineDialog from "@/components/Dialog/onlineDialog.vue";

export default {
  components: { LjzxDialog, OnlineDialog },
  data() {
    return {
      rjuv: '',
      zhl: null,
      kdj: null,
      ljzxOpen: false,
      zxzxOpen: false
    };
  },
  created() { },
  methods: {
    ljzx() {
      this.ljzxOpen = true;
    },
    closeDialog() {
      this.ljzxOpen = false;
    },
    zxzx() {
      this.zxzxOpen = true;
    },
    closeZxzxDialog() {
      this.zxzxOpen = false;
    },
    more(eleId) {
      this.scrollToEl(eleId)
    },
    scrollToEl(elementId) {
      const targetDiv = document.querySelector(`#${elementId}`);
      if (targetDiv) {
        targetDiv.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.third {
  background-color: #ffffff;
  font-size: 15px;

  // Hero核心优势区域 原有样式
  .advantage {
    margin: 0 auto;
    margin-top: 100px;
    width: 100%;
    height: 500px;
    background-color: #F20303;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    .hero-text-container {
      text-align: center;
      height: 42%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #ffffff;

      h1 {
        font-size: xxx-large;
        color: #ffffff;
      }

      p {
        font-size: large;
        padding: 20px;
      }
    }

    .hero-m-container {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 50px;

      .con {
        flex: 1;
        height: 241px;
        padding: 20px;
        background-color: #ffffff;
        border: 1px solid #f4f4f5;
        border-radius: 15px;
        position: relative;

        .sm {
          font-size: 14px;
          color: #606875;
        }

        img {
          width: 60px;
        }



        h2 {
          padding: 10px 0;
          font-weight: bold;
        }

        p {
          font-size: 14px;
          color: #606875;
          padding-bottom: 15px;
        }

        a {
          font-size: 14px;
          color: #F20303;
          position: absolute;
          bottom: 16px;
        }
      }
    }
  }

  // 新增：技术驱动模块样式（完全匹配图片设计，与原有样式统一）
  .tech-drive {
    width: 100%;
    background-color: #ffffff;

    .tech-drive-container {
      width: 80%;
      margin: 0 auto;
    }

    // 技术赋能三件事
    .tech-empower {
      background-color: #FDF2F2;
      padding: 35px 0;
      text-align: center;
      border-radius: 12px;
      margin-bottom: 70px;

      .empower-title {
        font-size: 22px;
        font-weight: 700;
        color: #333333;
        margin: 0 0 10px 0;
      }

      .empower-subtitle {
        font-size: 22px;
        color: #333333;
        font-weight: 700;
        margin: 0;
      }
    }

    // 核心能力
    .core-ability {
      text-align: center;
      margin-bottom: 80px;

      .ability-main-title {
        font-size: 30px;
        font-weight: 700;
        color: #333333;
        margin: 0 0 12px 0;
      }

      .ability-subtitle {
        font-size: 16px;
        color: #666666;
        margin: 0 0 50px 0;
      }

      .ability-list {
        display: flex;
        justify-content: space-between;
        gap: 30px;

        .ability-item {
          flex: 1;
          padding: 35px 25px;
          background-color: #F9F2F2;
          border: 1px solid #F4F4F5;
          border-radius: 15px;
          box-shadow: 0 2px 15px rgba(235, 236, 237, 0.8);
          text-align: left;

          .item-icon {
            width: 45px;
            height: 45px;
            border-radius: 8px;
            margin-bottom: 20px;
          }

          .item-title {
            font-size: 19px;
            font-weight: 700;
            color: #333333;
            margin: 0 0 12px 0;
          }

          .item-desc {
            font-size: 14px;
            color: #606875;
            line-height: 1.6;
            margin: 0;
          }
        }
      }
    }

    // 技术工作流
    .tech-workflow {
      background-color: #FDF2F2;
      padding: 50px 0;
      border-radius: 12px;
      position: relative;

      .workflow-main-title {
        font-size: 26px;
        font-weight: 700;
        color: #333333;
        text-align: center;
        margin: 0 0 10px 0;
      }

      .workflow-subtitle {
        font-size: 16px;
        color: #666666;
        text-align: center;
        margin: 0 0 40px 0;
      }

      .jsqd-content {
        margin-left: 50px;
        margin-top: 30px;

        .ant-timeline {

          .ant-timeline-item {
            padding: 0 0 50px;

            ::v-deep .ant-timeline-item-head {
              border-radius: 50%;
            }

            img {
              width: 40px;
            }

            .con {
              margin-left: 20px;
              font-size: 14px;
              color: #7e8690;

              h2 {
                font-weight: bold;
              }

              .card {
                padding: 10px;
                display: flex;
                gap: 20px;

                .font-semibold {
                  color: #262626;
                  font-weight: bold;
                }

                .item {
                  padding: 20px;
                  border: 1px solid #e1e1e9;
                  /* 可选：添加实体边框，与虚影搭配 */
                  border-radius: 10px;
                }
              }
            }
          }
        }
      }
    }
  }

  // 技术驱动的极致效果 原有样式
  .jsqd {
    width: 100%;
    height: 200px;
    padding-top: 50px;
    background-color: #ffffff;

    .jsqd-container {
      width: 65%;
      margin: 0 auto;

      .jsqd-title {
        text-align: center;
        padding: 0px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }


    }
  }

  // 资源优势 原有样式
  .zyys {
    margin-top: 50px;
    width: 100%;
    height: 718px;
    padding-top: 10px;
    background-color: #F9F2F2;

    .zyys-container {
      width: 80%;
      margin: 0 auto;
      background-color: #F9F2F2;

      .zyys-title {
        text-align: center;
        padding: 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .zyys-content {
        margin-top: 50px;

        .con {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 90px;

          .item {
            flex: 1;
            height: 450px;
            padding: 20px;
            display: flex;
            flex-direction: column;
            gap: 40px;
            border-radius: 20px;
            border: 1px solid #f4f4f5;
            box-shadow: 0 0 10px #ebecec;

            .title {
              font-size: xxx-large;
              font-weight: bold;
            }

            .text-2xl {
              font-size: x-large;
              font-weight: bold;
            }

            .fas {
              display: flex;
              flex-direction: column;
              gap: 15px;

              i {
                color: #F20303;
              }

              span {
                margin-left: 5px;
              }
            }

            .bottom {
              display: flex;
              background-color: #FFE4E6;

              .left-sh {
                width: 5px;
                background-color: #F20303;
                border-top-left-radius: 10px;
                border-bottom-left-radius: 10px;
              }

              p {
                padding: 10px;
              }

              span {
                font-weight: bold;
              }
            }
          }

          .one {
            background: linear-gradient(to bottom right, #fdfefd, #f1fdf5);

            .title {
              color: #F20303;
            }
          }

          .two {
            background: linear-gradient(to bottom right, #fefeff, #f0f7ff);

            .title {
              color: #F20303;
            }
          }

          .three {
            background: linear-gradient(to bottom right, #fefeff, #faf6ff);

            .title {
              color: #F20303;
            }

            i {
              color: #F20303 !important;
            }
          }
        }
      }
    }
  }

  // 模式优势 原有样式
  .msys {
    width: 100%;
    height: 850px;
    background-color: #F9FAFB;

    .msys-container {
      width: 80%;
      margin: 0 auto;
      padding-top: 50px;

      .msys-title {
        text-align: center;
        padding: 20px;
        font-size: xx-large;
        font-weight: bold;
        color: rgba(0, 0, 0, 0.85);
      }

      .msys-content {
        margin-top: 50px;

        .con {
          background-color: #ffffff;
          border: 1px solid #f4f4f5;
          border-radius: 15px;
          box-shadow: 0 0 10px #ebecec;

          .title {
            font-size: x-large;
            font-weight: bold;
            text-align: center;
            margin-top: 30px;
          }

          .content {
            padding: 30px 30px 10px 30px;
            font-size: 15px;

            .el-row {
              padding: 20px 0;
            }

            .item {
              border: 1px solid #e7e9ed;
              border-radius: 15px;
              padding: 15px;
              height: 170px;

              .item-title {
                display: flex;
                gap: 5px;
                align-items: center;

                span {
                  font-size: large;
                  font-weight: bold;
                }

                img {
                  width: 40px;
                }
              }

              .item-content {
                padding: 5px 0;
                display: flex;
                flex-direction: column;
                gap: 5px;
              }
            }

            .two {
              .item-content {
                i {
                  color: #55d283;
                }

                span {
                  margin-left: 5px;
                }
              }
            }

            .three {
              .item-content {
                display: flex;
                flex-direction: row;
                gap: 20px;

                div {
                  padding: 15px;
                  width: 350px;
                  background-color: #eff6ff;
                  border-radius: 10px;

                  span {
                    font-weight: bold;
                  }
                }
              }
            }
          }

          .foot {
            margin-bottom: 30px;
            display: flex;
            justify-content: center;
            align-items: center;

            .foot-btn {
              width: 190px;
              height: 46px;
              line-height: 46px;
              background-color: #F20303;
              border-radius: 5px;
              font-size: 15px;
              color: white;
              text-align: center;
            }
          }
        }
      }
    }
  }

  // 底部咨询 原有样式（已保留线性渐变可直接启用）
  .body-foot {
    width: 100%;
    height: 330px;
    // 如需线性渐变可启用以下代码，替换单一背景色
    // background: linear-gradient(to bottom, #D90202, #F20303);
    background-color: #F20303;
    background-image: linear-gradient(to right, #F20303, #F20303, #DBB6B6);

    .con {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 20px;

      h2 {
        color: white;
        font-size: 35px;
        margin-top: 90px;
      }

      p {
        color: #89b9cb;
        font-size: large;
      }

      button {
        margin-top: 10px;
        color: #F20303;
        font-size: large;
        font-weight: bold;

        .i {
          margin: 3px;
        }
      }
    }
  }
}
</style>